import { ActionReducerMapBuilder, createSlice } from '@reduxjs/toolkit'
import { GeneratePackageIdInitialStateType } from 'features/SupplyOrder/@types/GeneratePackageId'
import { withLoadingReducer } from 'utils/reducerHandler'
import {
  fetchPackageIDList,
  generatePackageID,
  fetchPackageIdDetails,
  SLICE_NAME_GENERATE_PACEKAGE_ID,
} from './thunk'

const initialState: GeneratePackageIdInitialStateType = {
  isLoading: true,
  data: [],
  packageIdDetails: [],
}

const generatePackageIdSlice = createSlice({
  name: SLICE_NAME_GENERATE_PACEKAGE_ID,
  initialState,
  reducers: {
    resetGeneratePackageIdState: () => initialState,
  },
  extraReducers: withLoadingReducer(
    (builder: ActionReducerMapBuilder<GeneratePackageIdInitialStateType>) => {
      builder.addCase(fetchPackageIDList.fulfilled, (state, action) => {
        state.data = action.payload.data
      })
      builder.addCase(fetchPackageIdDetails.fulfilled, (state, action) => {
        state.packageIdDetails = action.payload.data
      })
    },
    [fetchPackageIDList, generatePackageID, fetchPackageIdDetails],
  ),
})

export const { resetGeneratePackageIdState } = generatePackageIdSlice.actions

export default generatePackageIdSlice.reducer
